import { CatchDialog } from 'src/components/catches/CatchDialog';

export const EventCatchDialog = ({ trap_id, event, mutate, onClose, show }) => (
  <CatchDialog
    show={show}
    trap_id={trap_id}
    catchItem={event}
    mutate={mutate}
    onClose={onClose}
    editable
    allowUpload
    allowDeletePhoto
    allowDownload
    showDeleteAlarm
  />
);
